import React from 'react'
import PropTypes from 'prop-types'

const ExperienceStatuses = [
  { value: 'active', description: 'Active experiences' },
  { value: 'scheduled', description: 'Scheduled experiences' },
  { value: 'draft', description: 'Draft experiences' },
  { value: 'paused', description: 'Paused experiences' },
  { value: 'expired', description: 'Expired experiences' },
  { value: 'archived', description: 'Archived experiences' },
  { value: 'all', description: 'All experiences' }
]

const StatusFilter = ({ onFilter }) => (
  <div className='br-experience-filter'>
    <span>Status:</span>
    <select className='selectpicker' onChange={onFilter}>
      {ExperienceStatuses.map(status => (
        <option value={status.value} key={status.value}>
          {status.description}
        </option>
      ))}
    </select>
  </div>
)

StatusFilter.displayName = 'StatusFilterComponent'

StatusFilter.propTypes = {
  onFilter: PropTypes.func
}

export default StatusFilter



// WEBPACK FOOTER //
// ./src/pages/my-experiences/status-filter/index.js